import { useEffect, useState } from 'react';

/**
 *  As use effect is not run on the remix SSR side, we can rely on this boolean to indicate we are on a client side render cycle
 */
export default function useIsClient() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
}
